import type { TelegramUser } from '../types';

export interface TelegramWebAppLike {
  initData: string;
  initDataUnsafe: {
    user?: TelegramUser;
    query_id?: string;
    auth_date?: number;
    hash?: string;
  };
  version: string;
  platform: string;
  colorScheme: 'light' | 'dark';
  themeParams: Record<string, string>;
  isExpanded: boolean;
  viewportHeight: number;
  viewportStableHeight: number;
  headerColor: string;
  backgroundColor: string;
  isClosingConfirmationEnabled: boolean;
  BackButton?: {
    isVisible: boolean;
    onClick(callback: () => void): void;
    offClick(callback: () => void): void;
    show(): void;
    hide(): void;
  };
  ready?: () => void;
  expand?: () => void;
  close?: () => void;
  openTelegramLink?: (url: string) => void;
  openLink?: (url: string, options?: { try_instant_view?: boolean }) => void;
  MainButton?: {
    text: string;
    show(): void;
    hide(): void;
    enable(): void;
    disable(): void;
    onClick(callback: () => void): void;
    offClick(callback: () => void): void;
    setText(text: string): void;
    showProgress(leaveActive?: boolean): void;
    hideProgress(): void;
    setParams(params: { text?: string; color?: string; text_color?: string; is_active?: boolean; is_visible?: boolean }): void;
  };
  HapticFeedback?: {
    impactOccurred(style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft'): void;
    notificationOccurred(type: 'error' | 'success' | 'warning'): void;
    selectionChanged(): void;
  };
}

const DEV_TELEGRAM_USER: TelegramUser = {
  id: 999999,
  first_name: 'Test',
  username: 'dev_user',
};

const DEV_WEB_APP: TelegramWebAppLike = {
  initData: '',
  initDataUnsafe: {
    user: DEV_TELEGRAM_USER,
  },
  version: '0.0.0',
  platform: 'browser',
  colorScheme: 'dark',
  themeParams: {},
  isExpanded: true,
  viewportHeight: typeof window !== 'undefined' ? window.innerHeight : 0,
  viewportStableHeight: typeof window !== 'undefined' ? window.innerHeight : 0,
  headerColor: '#000000',
  backgroundColor: '#000000',
  isClosingConfirmationEnabled: false,
  ready: () => {},
  expand: () => {},
  close: () => {},
};

declare global {
  interface Window {
    Telegram?: {
      WebApp: TelegramWebAppLike;
    };
  }
}

export function isTelegramAvailable(): boolean {
  return typeof window !== 'undefined' && !!window.Telegram?.WebApp;
}

export function getTelegram(): TelegramWebAppLike {
  if (isTelegramAvailable()) {
    return window.Telegram!.WebApp;
  }

  return DEV_WEB_APP;
}

export function getDevTelegramUser(): TelegramUser {
  return DEV_TELEGRAM_USER;
}
